import api from '../api/index'

const state = {
  checkpoints: [],
  focusedCP: ''
}

const mutations = {
  setCPS: function (state, payload) {
    state.checkpoints = payload
  },
  setFocusCP: function (state, payload) {
    state.focusedCP = payload
  }
}

const actions = {
  cps: function (context, checkpoints) {
    context.commit('setCPS', checkpoints)
  },
  focusCP: function (context, cpid) {
    context.commit('setFocusCP', cpid)
  },
  loadRaceCheckpoints: function (context, raceId) {
    api.getRaceCheckpoints(raceId, function (data) {
      var object={};
      for(var i=0;i<data.length;i+=1)
      {
        object[data[i].id]=data[i];
      }
      context.commit('setCPS', object)
    })
  }
}

const getters = {
  checkpoints: state => {
    return state.checkpoints
  },
  checkpointProfile: state => {
    let data = []
    for (let i in state.checkpoints) {
      let point = state.checkpoints[i].point
      data.push({
        x: point.distance / 1000,
        y: point.elevation,
        cp_id: state.checkpoints[i].id,
        cp_name: state.checkpoints[i].name
      })
    }
    return data
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/checkpoints.js